import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const styles = {
  locationChip: css`
    max-width: none;
  `,
  balanceTag: {
    default: css`
      color: ${theme.colorsV2.neutral70()};
      background-color: ${theme.colorsV2.neutral50(25)};
    `,
    new: css`
      color: ${theme.colorsV2.blue70()};
      background-color: ${theme.colorsV2.blue50(25)};
    `,
    update: css`
      color: ${theme.colorsV2.eggplant70()};
      background-color: ${theme.colorsV2.eggplant50(25)};
    `,
    exists: css`
      color: ${theme.colorsV2.tangerine70()};
      background-color: ${theme.colorsV2.tangerine50(25)};
    `,
  },
};
